export enum AudienceTypeEnum {
    NORMAL = 1,
    COMMUNITY = 2,
    AUTOMATIC = 3,
}
